import React from "react";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addFilter, addFilterList } from "../../../Redux/slices/eventSlice";
import PropTypes from "prop-types";

const CategoryCard = ({ data, index }) => {
  CategoryCard.propTypes = {
    data: PropTypes.object,
    index: PropTypes.number,
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEventDetails = () => {
    window.scrollTo(0, 0);
    dispatch(
      addFilterList({
        type: "Category",
        value: data.text,
      })
    );
    dispatch(
      addFilter({
        category: data.value,
      })
    );
    navigate(`/events`, { state: { index } });
  };

  return (
    <div
      onClick={handleEventDetails}
      onKeyDown={handleEventDetails}
      className="category-card-container"
      style={{
        height: 220,
        backgroundColor: data.color,
        padding: "32px 24px",
        cursor: "pointer",
        borderRadius: 14,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          fontWeight: 700,
          fontSize: 24,
          color: "#fff",
        }}
        className="cat-card-title"
      >
        {data?.text}
      </div>
      <img
        src={data?.img}
        alt="icon"
        className="category-card-image"
        style={{
          position: "absolute",
          bottom: 0,
          right: 12,
          height: 180,
          borderRadius: "0px 0px 14px 0px",
        }}
      />
    </div>
  );
};

export default CategoryCard;
